const actionsTypes = {
    CLICK_OPEN_MENU: 'CLICK_OPEN_MENU',
    URL_PROFILE_PHOTO: 'URL_PROFILE_PHOTO',
    PUBLIC_CODE: 'PUBLIC_CODE',
    SET_CURRENT_COMPANY: 'SET_CURRENT_COMPANY',
    SET_COMPANIES: 'SET_COMPANIES',
    SET_USER_ROLES: 'SET_USER_ROLES',
}

export default actionsTypes;